import { Crown, Star, Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PlanBadgeProps {
  plan: string;
  className?: string;
}

const PLAN_CONFIG: Record<string, { label: string; icon: React.ElementType; bgColor: string; textColor: string }> = {
  free: {
    label: 'Free',
    icon: Star,
    bgColor: 'bg-muted',
    textColor: 'text-muted-foreground',
  },
  oposiciones: {
    label: 'Opositor',
    icon: Sparkles,
    bgColor: 'bg-[#2E0E88]/10',
    textColor: 'text-[#2E0E88]',
  },
  pro_monthly: {
    label: 'Pro',
    icon: Crown,
    bgColor: 'bg-[#06D3AA]/10',
    textColor: 'text-[#06D3AA]',
  },
  pro_yearly: {
    label: 'Pro',
    icon: Crown,
    bgColor: 'bg-[#06D3AA]/10',
    textColor: 'text-[#06D3AA]',
  },
  pro: {
    label: 'Pro',
    icon: Crown,
    bgColor: 'bg-[#06D3AA]/10',
    textColor: 'text-[#06D3AA]',
  },
};

export function PlanBadge({ plan, className }: PlanBadgeProps) {
  const config = PLAN_CONFIG[plan] || PLAN_CONFIG.free;
  const Icon = config.icon;

  return (
    <div 
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium',
        config.bgColor,
        config.textColor,
        className
      )}
    >
      <Icon className="h-3 w-3" />
      <span>{config.label}</span>
    </div>
  );
}
